import { useUpperSeo } from "../../../hooks";

import { Description, Title, Wrapper } from "./HeadUpperSeo.styled";

const HeadUpperSeo = () => {
  const { title, createDescMarkup } = useUpperSeo();

  return (
    <Wrapper>
      <Title>{title}</Title>

      <Description dangerouslySetInnerHTML={createDescMarkup()} />
    </Wrapper>
  );
};

export default HeadUpperSeo;
